import { render } from "./EditSystem.vue?vue&type=template&id=1f9cf7f6&ts=true"
import script from "./EditSystem.vue?vue&type=script&lang=ts"
export * from "./EditSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__